module.exports = __webpack_public_path__ + "static/media/YF68_2.4704404e.jpg";